/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
export type UserSelectFragment = {
  readonly __typename: "User";
  readonly userId: c.UserId;
};

export type GroupSelectFragment = {
  readonly __typename: "Group";
  readonly groupId: c.GroupId;
};

export type IntrinsicGroupSelectFragment = {
  readonly __typename: "IntrinsicGroup";
  readonly intrinsicGroupId: Types.IntrinsicGroupId;
};

export type UserSelectRenderingFragment = {
  readonly __typename: "User";
  readonly email: string;
  readonly active: boolean;
  readonly imageUrl: string | null;
  readonly orgRole: Types.OrgRole;
  readonly userName: string | null;
  readonly userId: c.UserId;
};

export type GroupSelectRenderingFragment = {
  readonly __typename: "Group";
  readonly groupName: string;
  readonly groupId: c.GroupId;
  readonly userGroupLinks: ReadonlyArray<{
    readonly __typename: "UserGroupLink";
    readonly id: c.UserGroupLinkId;
  }>;
};

export type IntrinsicGroupSelectRenderingFragment = {
  readonly __typename: "IntrinsicGroup";
  readonly userCount: number;
  readonly intrinsicGroupName: string;
  readonly intrinsicGroupId: Types.IntrinsicGroupId;
};

export const UserSelectFragmentDoc = /*#__PURE__*/ gql`
  fragment UserSelectFragment on User {
    userId: id
  }
`;
export const UserSelectRenderingFragmentDoc = /*#__PURE__*/ gql`
  fragment UserSelectRenderingFragment on User {
    ...UserSelectFragment
    userName: name
    email
    active
    imageUrl
    orgRole
  }
  ${UserSelectFragmentDoc}
`;
export const GroupSelectFragmentDoc = /*#__PURE__*/ gql`
  fragment GroupSelectFragment on Group {
    groupId: id
  }
`;
export const GroupSelectRenderingFragmentDoc = /*#__PURE__*/ gql`
  fragment GroupSelectRenderingFragment on Group {
    ...GroupSelectFragment
    groupName: name
    userGroupLinks(includeDeactivated: false) {
      id
    }
  }
  ${GroupSelectFragmentDoc}
`;
export const IntrinsicGroupSelectFragmentDoc = /*#__PURE__*/ gql`
  fragment IntrinsicGroupSelectFragment on IntrinsicGroup {
    intrinsicGroupId: id
  }
`;
export const IntrinsicGroupSelectRenderingFragmentDoc = /*#__PURE__*/ gql`
  fragment IntrinsicGroupSelectRenderingFragment on IntrinsicGroup {
    ...IntrinsicGroupSelectFragment
    intrinsicGroupName: name
    userCount
  }
  ${IntrinsicGroupSelectFragmentDoc}
`;
